import * as PaymentService from 'services/payment-service';
import * as OTRPaymentService from 'services/otr/otr-payment-service';

export function resetState(type) {
  return function (dispatch) {
    dispatch(reset(type));
  };
}

export function findBills(driverId, params, isOTR, page, pageSize) {
  return async function (dispatch) {
    dispatch(process());
    try{
      const paymentService = isOTR ? OTRPaymentService : PaymentService;
      const response = await paymentService.findBills(driverId, params, page, pageSize);
      dispatch(success('FETCH_BILLS', response.data));
    } catch(err) {
      dispatch(error('BILL_ERROR', err));
    }
  };
}

export function save(bill, isOTR) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const paymentService = isOTR ? OTRPaymentService : PaymentService;
      const response = await paymentService.save(bill);
      return dispatch(success('ADD_BILL', response.data));
    } catch (err) {
      return dispatch(error('BILL_ERROR', err));
    }
  };
}

export function update(bill, isOTR) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const paymentService = isOTR ? OTRPaymentService : PaymentService;
      const response = await paymentService.update(bill);
      return dispatch(success('UPDATE_BILL', response.data));
    } catch (err) {
      return dispatch(error('BILL_ERROR', err));
    }
  };
}

export function revertDriverPayment(billIds, isOTR) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const paymentService = isOTR ? OTRPaymentService : PaymentService;
      const response = await paymentService.unpayDriverLegs(billIds);
      dispatch(success('UNPAY_DRIVER', response.data));
    } catch(err) {
      dispatch(error('BILL_ERROR', err));
    }
  };
}

export function processPayment(payment, isOTR) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const paymentService = isOTR ? OTRPaymentService : PaymentService;
      const response = await paymentService.processBillPayment(payment);
      dispatch(success('BILL_PAYMENT_SUCCESS', response.data));
    } catch(err) {
      dispatch(error('BILL_ERROR', err));
    }
  };
}

function reset(type) {
  return {
    type: type,
  };
}

function process() {
  return {
    type: 'PROCESSING_BILL',
  };
}

function success(type, data) {
  return {
    type: type,
    payload: data
  };
}
function error(type, err) {
  let message;
  if (err.response) {
    // Request made and server responded
    const { data } = err.response;
    message = data && data.message;
  } else if (err.request) {
    // The request was made but no response was received
    message = err.request;
  } else {
    // Something happened in setting up the request that triggered an Error
    message = err.message;
  }
  return {
    type: type,
    payload: message,
  };
}